import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import { useTranslate } from "src/locales";

interface VitalSignsDateTimeSectionProps {
    value: Date | null;
    onChange: (value: Date | null) => void;
    disabled?: boolean;
}

export const VitalSignsDateTimeSection = ({ value, onChange, disabled }: VitalSignsDateTimeSectionProps) => {
    const { t } = useTranslate();

    return (
        <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", borderBottom: "1px solid #E0E0E0", py: 1.5 }}
        >
            <Grid
                xs={12}
                sm={4}
                md={4}
            >
                <ByzMuiTypography sx={{ marginLeft: "10px" }}>
                    {t("datetime")}
                </ByzMuiTypography>
            </Grid>
            <Grid xs={12} sm={8} md={8}>
                <ByzMuiDateTimePicker
                    sx={{ width: "100%" }}
                    slotProps={{
                        textField: { fullWidth: true },
                    }}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    label={t("datetime")}
                />
            </Grid>
        </Grid>
    );
};
